import { render } from "./TypographyExample.vue?vue&type=template&id=593a437b"
import script from "./TypographyExample.vue?vue&type=script&lang=js"
export * from "./TypographyExample.vue?vue&type=script&lang=js"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__